var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.986 3.797a.297.297 0 00-.237-.209l-3.1-.472L5.263.171A.292.292 0 005 0a.292.292 0 00-.263.171L3.351 3.116l-3.1.472a.297.297 0 00-.237.21.317.317 0 00.074.314l2.244 2.292-.53 3.237a.314.314 0 00.117.3.284.284 0 00.308.024L5 8.437l2.773 1.528a.282.282 0 00.308-.024.314.314 0 00.117-.3l-.53-3.237 2.244-2.292a.317.317 0 00.074-.315z",
    fill: "#F0B31F"
  })));
}
export default SvgStar;